import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { symantecEDRThrottleEnabled, disableTLSCheck } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "symantecEDRThrottleEnabled",
      defaultChecked: symantecEDRThrottleEnabled == null ? void 0 : symantecEDRThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "disableTLSCheck",
      type: "checkbox",
      value: "disable-tlsCheck",
      defaultChecked: disableTLSCheck == null ? void 0 : disableTLSCheck.value,
      onChange,
      label: "Disable TLS Validation",
      help: "Disable the TLS validation and trust all connection?"
    }
  ));
};
export default FormAdvancedOptions;
